// extracted by mini-css-extract-plugin
export default {"backdrop":"react_app_layout___backdrop___a1a49a83","isVisible":"react_app_layout___isVisible___a0694414"};